import Snacks from '../Snacks'
import "../styles/index.css"



export default function Index() {
  return (
    <div>
      <Snacks/>  
  </div>

  )
}